<template>
  <div
    :data-qa="dataQa"
    :class="$props.class"
    :style="style"
  >
    <base-label>
      <span
        v-if="label"
        :class="$style.label"
      >{{ label }}</span>
    </base-label>
    <default-wysiwyg v-bind="$attrs" />
  </div>
</template>

<script>
import DefaultWysiwyg from '@/components/wysiwyg/default-wysiwyg/default-wysiwyg.vue';
import BaseLabel from '@/shared/legacy/ui/label/label.vue';

export default {
  name: 'FormFieldWysiwyg',
  components: {
    BaseLabel,
    DefaultWysiwyg
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: undefined
    },
    dataQa: {
      type: String,
      default: undefined
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  }
};
</script>

<style lang="less" module>
.label {
  display: block;
  margin-bottom: 3px;
}
</style>

<i18n lang="json">{}</i18n>
